<template>
	<div class="page">
		<div class="fixed-top">
			<NoticeBar
				left-icon="volume-o"
				text="交易有风险，请在香肠树App-探索频道-联系官方客服担保交易！货者网暂时无法提供鉴定服务！合作咨询：17165259999"
			/>
		</div>
		<div class="page-body" :style="listStyle">
      <iframe src="http://nifen.com:52222/?action=sheng_ri_jiu_index.html" frameborder="0" style="width:100%;height:100%;" id="iframeBox"></iframe>
		</div>
	</div>
</template>

<script>
	import { NavBar, Image as VanImage, Icon, Cell, Button, NoticeBar, PullRefresh, List, Search } from 'vant'

	export default {
	  components: { NavBar, VanImage, Icon, Cell, Button, NoticeBar, PullRefresh, List, Search },
    data () {
      return {
        value: '',
	      showSearch: false,
	      list: [],
	      page: 1,
	      size: 20,
        error: false,
        loading: false,
        finished: false,
        refreshing: false
      }
    },
		computed: {
	    listStyle() {
	      if(this.showSearch) {
	        return {
	          paddingTop: '40px'
	        }
	      } else {
	        return {
            paddingTop: '40px'
	        }
	      }
	    }

		},
		mounted() {
	    console.log('market.vue init')
		},
    methods: {
      onBackClick () {},
      onSearchClick () {
        this.showSearch = !this.showSearch
      },
      onMoreClick () {},
      onItemClick(target) {
        this.$router.push({
          name: 'goodDetail',
          query: {
            id: target.goodsInfo.id
          }
        })
      },
      onBuyClick(item) {
        this.$router.push({
          name: 'orderPay',
          params: { ...item }
        })
      },
      onSearch() {
        this.showSearch = false;
        this.refreshing = true;
        this.onRefresh({goodsName: this.value});
      },
      onRefresh(param) {
        this.finished = false;
        this.loading = true;
        this.onLoad(param);
      },
      onLoad(condition) {
        if (this.refreshing) {
          this.page = 1;
          this.list = [];
          this.refreshing = false;
        }

        const targetParam = {
          page: this.page++,
          size: this.size
        };

        this.$store.dispatch('fetchGoods', {...targetParam, ...condition})
          .then(({rows, total}) => {
            this.list = [].concat(this.list, rows);
            this.loading = false;
            if (this.list.length >= total) {
              this.finished = true;
            }
          })
          .catch(() => {
            this.loading = false;
            this.error = true
            this.finished = true;
          })
      },
    }
	}
</script>

<style lang="less" scoped>
	.fixed-top {
		position: fixed;
		top: 0px;
		left: 0;
		right: 0;
		z-index: 2;
	}
	.page {
		height: 100%;
	}

	.van-nav-bar {
		display: flex;
		align-items: center;
		.left {
			display: flex;
			align-items: center;
		}
		.right {
			display: flex;
			align-items: center;
		}
	}

	.page-body {
		padding-top: 40px;
		padding-bottom: 15px;
		box-sizing: border-box;
		height: 100%;

		/deep/.van-pull-refresh {
			min-height: 100%;
		}
	}
</style>
